import React from "react";
import { H3, Text } from "@blueprintjs/core";

class SurgeryVideoTab extends React.Component {
  render() {
    return (
      <div style={{ padding: "20px" }}>
        <H3 style={{ marginBottom: "20px", color: "var(--text-primary)" }}>Surgery Video</H3>
        <Text style={{ color: "var(--text-secondary)" }}>
          This tab will contain video upload, metadata, and HTML5 player functionality.
        </Text>
        {/* TODO: Implement surgery video functionality */}
      </div>
    );
  }
}

export default SurgeryVideoTab;
